import IconRank from '@/components/assets/icon_rank.svg'

type ActionWorldCardRankingBadgeProps = {
  index?: number
}

export default function ActionWorldCardRankingBadge({ index }: ActionWorldCardRankingBadgeProps) {
  if (index === undefined) {
    return null
  }

  return (
    <div className="absolute -top-4 left-2 z-interactive grid aspect-[24/31] w-[44px] place-items-center">
      <span className="body-1 text-vive-white absolute z-interactive font-semibold">{index}</span>
      <IconRank />
    </div>
  )
}
